// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toBagButton":"toBagButton_ui6Ul","deleteButton":"deleteButton_tw8pJ"};